import { useFormContext } from "react-hook-form";
import { Video } from "lucide-react";
import { FormControl, FormField, FormItem, FormLabel } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Switch } from "@shared-kernel/primary/shared/shadcn/ui/switch";
import { TeacherPublicProfileSubform } from "@user-management-context/primary/teacher/teacher-public-profile-subform/teacher-public-profile.subform";
import type { PublicProfileStepInputs } from "../form-validation/public-profile-step.schema";

const OnlineCoachingToggle = () => {
  const { control, setValue } = useFormContext<PublicProfileStepInputs>();

  return (
    <section className="space-y-3">
      <h3 className="text-sm font-semibold">Modalités de coaching</h3>
      <FormField
        control={control}
        name="offersOnlineCoaching"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start justify-between gap-4 rounded-lg border p-4">
            <div className="flex items-start gap-3">
              <Video className="mt-0.5 size-5 text-muted-foreground" />
              <div className="space-y-1">
                <FormLabel>Coachings en visio</FormLabel>
                <p className="text-sm text-muted-foreground">Je peux dispenser mes coachings en visio.</p>
              </div>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={checked => setValue("offersOnlineCoaching", checked, { shouldDirty: true, shouldValidate: true })}
                data-testid="offers-online-coaching-switch"
              />
            </FormControl>
          </FormItem>
        )}
      />
    </section>
  );
};

export const PublicProfileStep = () => {
  return <TeacherPublicProfileSubform teachingVenuesSlot={<OnlineCoachingToggle />} />;
};
